import { bfsSsoHttp } from '@/utils/http/index.js'

/**
 * 获取微信扫码json
 * https://yapi.ops.yunlizhi.cn/project/18/interface/api/21471
 */
// eslint-disable-next-line import/prefer-default-export
export function getCode (param){
    return bfsSsoHttp.get({
        url: '/login/get_wechat_qrcode?wechatAccountCode=open_consignor_web',
        param,
    })
}